import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useSearch } from "@tanstack/react-router";
import { Stack } from "@bookingcom/bui-react";
import { resolveDateRange } from "../../utils/searchParams";
import type { DateRangeSearchParams } from "../../utils/searchParams";
import { DiscountedBookingsChartCard } from "../Charts/DiscountedBookingsChart";
import { AverageDiscountChartCard } from "../Charts/AverageDiscountChart";
import { ChartsDataGuard } from "../Charts/ChartsDataGuard";
import { PageErrorState } from "../Charts/PageErrorState";
import { LoadingSpinner } from "../LoadingSpinner";

export const OverviewCharts = () => {
  const { startDate: startDateStr, endDate: endDateStr, quickSelect } = useSearch({ strict: false }) as DateRangeSearchParams;
  const { startDate, endDate } = resolveDateRange({ startDate: startDateStr, endDate: endDateStr, quickSelect });

  return (
    <ErrorBoundary fallbackRender={() => <PageErrorState />}>
      <Suspense fallback={<LoadingSpinner />}>
        <ChartsDataGuard from={startDate} to={endDate}>
          <Stack gap={6}>
            <DiscountedBookingsChartCard from={startDate} to={endDate} />
            <AverageDiscountChartCard from={startDate} to={endDate} />
          </Stack>
        </ChartsDataGuard>
      </Suspense>
    </ErrorBoundary>
  );
};
